<p class="modal-title">Admin: Add Filter</p>
<div class="body flex flex-col">
  <form [formGroup]="muteForm" (ngSubmit)="onSubmit()" #muteFormRef="ngForm">
    <app-form-field
      [label]="'Phrase'"
      [formControl]="phrase"
      [errorType]="'outline'"
      [id]="'time'"
      [submitting]="false"
      [placeholder]="'Enter Phrase...'"
      [error]="
        !phrase.valid && muteFormRef['submitted'] ? 'Field is required' : ''
      "
    />
    <app-form-field
      [label]="'Auto Mute (in minutes/leave blank for no mute)'"
      [formControl]="auto"
      [errorType]="'outline'"
      [id]="'reason'"
      [submitting]="false"
      [placeholder]="'Enter Auto Mute...'"
      [error]="
        !auto.valid && muteFormRef['submitted'] ? 'Field is required' : ''
      "
    />
    <button class="button button--style-yellow h-32 padding-x-12" type="submit">
      Add Filter
    </button>
  </form>
</div>
